module.exports = __webpack_public_path__ + "static/media/adh2.dba5dca3.jpg";